import { NgModule } from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { NotesComponent } from './notes.component';

@NgModule({
  declarations: [NotesComponent],
  imports: [FormField],
  exports: [NotesComponent],
})
export class NotesModule {}
